'use strict';
import luxy from 'luxy.js';

export function LuxySet() {
  luxy.init({
    wrapper: '.l-main',
    targets : '.luxy-el',
    wrapperSpeed:  0.1
  });
}
